// extracted by mini-css-extract-plugin
export default {"button":"UserInitials_button__poDSk"};